import React, { useContext } from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import * as urlService from "../../view/urlService";
import { TableContext } from "../../index";
import { sortObjectsByAlphabet } from "../../utils";

function ChooseDeviceFieldSearch({ selectedType, setDeviceId, deviceId, devices = [] }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);
    const deviceList = Array.isArray(devices) ? devices : [];

    // const onChange = (value) => {
    //     setDeviceId(value);
    //     setConfig({ ...config, deviceId: value });

    //     if (Number(value) === -1) {
    //         history.push({
    //             pathname: history.pathname,
    //             search: urlService.removeFilter('device')
    //         })
    //         return;
    //     }

    //     const device = devices.find(device => device.id === Number(value));

    //     if (device) {
    //         history.push({
    //             pathname: history.pathname,
    //             search: urlService.updateFilters('device', device.hostName)
    //         })
    //     }
    // }

    // let devicesToRender = devices.filter(device => device.deviceType.id === Number(selectedType));
    // devicesToRender = sortObjectsByAlphabet(devicesToRender, 'hostName');

    const devicesToRender = sortObjectsByAlphabet(
        deviceList.filter(device => Number(device?.deviceType?.id) === Number(selectedType)),
        'hostName'
    );

    const options = devicesToRender.map(device => ({
        value: device.id,
        label: device.hostName
    }));

    const onChange = (selectedOption) => {
        const value = selectedOption?.value ?? -1;
        setDeviceId(value);
        setConfig({ ...config, deviceId: value });

        if (Number(value) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            });
            return;
        }

        const device = deviceList.find(device => device.id === Number(value));
        if (device) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('device', device.hostName)
            });
        }
    };

    return (
        <Select
            id="deviceName"
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(option => option.value === deviceId) || null}
            onChange={onChange}
            options={options}
            isSearchable
            placeholder="Choose"
            noOptionsMessage={() => "No devices available"}
        />
    );
    // return (
    //     <div className="oct_form-group">
    //         <label htmlFor="deviceName">Choose Device</label>
    //         <select className="form-control oct_select" id="deviceName"
    //             value={deviceId}
    //             onChange={event => onChange(event.target.value)}>
    //             <option value={-1}>Choose</option>
    //             {
    //                 devicesToRender &&
    //                 devicesToRender
    //                     .map((device, index) => <option key={index} value={device.id}>{device.hostName}</option>)
    //             }
    //             {
    //                 !devicesToRender || devicesToRender.length === 0 ?
    //                     <option disabled={true} /* selected={true} */> No devices available </option>
    //                     : null
    //             }
    //         </select>
    //     </div>
    // );
    }

export default (ChooseDeviceFieldSearch);
